const state = {
  backupReport: null,
  isCreatingReport: false,
  isSubmittingReportUpdate: false,
  modalData: {},
  reports: [],
  roleOptions: [
    { text: 'Viewer', value: 'viewer' },
    { text: 'Editor', value: 'editor' },
    { disabled: true, text: 'Owner', value: 'owner' },
  ],
  selectedReport: null,
  showArchivedReports: false,
  showModalArchiveReport: false,
  showModalDisplayAsFavorite: false,
  showModalDisplayAsMetric: false,
  showModalEnforceCriteria: false,
  showModalReportInfo: false,
  showModalShare: false,
  showModalUserInputValue: false,
  showShareFormInputs: false,
}

export default state
